import { IApplicationState } from '../../types/redux';

export const getUtmSource = (state: IApplicationState) => state.utmSource;
